export interface IBlog {
  id?: number;
  blogTitle?: string;
  blogContent?: string;
  image1ContentType?: string | null;
  image1?: string | null;
  image2ContentType?: string | null;
  image2?: string | null;
  image3ContentType?: string | null;
  image3?: string | null;
}

export const defaultValue: Readonly<IBlog> = {};
